import { useState, useRef, useEffect } from 'react';

/**
 * DeviceCell — shows a device count badge with a popover listing device names.
 * @param {{ devices: Array<{ device_id: number, device_name: string, manufacture_uuid: string }> }} props
 */
const DeviceCell = ({ devices }) => {
  const [open, setOpen] = useState(false);
  const popoverRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (popoverRef.current && !popoverRef.current.contains(e.target)) {
        setOpen(false);
      }
    };
    if (open) {
      document.addEventListener('mousedown', handleClickOutside);
    }
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [open]);

  if (!devices || devices.length === 0) {
    return <span className="rp-cell-text--muted">None</span>;
  }

  return (
    <div className="rp-device-cell" ref={popoverRef}>
      <button
        type="button"
        onClick={() => setOpen(!open)}
        onMouseEnter={() => setOpen(true)}
        onMouseLeave={() => setOpen(false)}
        className="rp-device-badge"
        aria-label={`${devices.length} device${devices.length !== 1 ? 's' : ''} assigned`}
      >
        <svg className="rp-icon-sm" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" aria-hidden="true">
          <path strokeLinecap="round" strokeLinejoin="round" d="M10.5 1.5H8.25A2.25 2.25 0 006 3.75v16.5a2.25 2.25 0 002.25 2.25h7.5A2.25 2.25 0 0018 20.25V3.75a2.25 2.25 0 00-2.25-2.25H13.5m-3 0V3h3V1.5m-3 0h3" />
        </svg>
        {devices.length} {devices.length === 1 ? 'device' : 'devices'}
      </button>

      {open ? (
        <div className="rp-device-popover" role="tooltip">
          <p className="rp-device-popover__title">
            Assigned Devices
          </p>
          <ul className="rp-device-popover__list">
            {devices.map((d) => (
              <li key={d.device_id} className="rp-device-popover__item">
                <span className="rp-device-popover__name">{d.device_name}</span>
                <span className="rp-device-popover__uuid">{d.manufacture_uuid}</span>
              </li>
            ))}
          </ul>
        </div>
      ) : <></>}
    </div>
  );
};

export default DeviceCell;
